export enum FeedbackType {
  CUSTOMER_SATISFACTION = 'customer-satisfaction',
  LIKE_DISLIKE = 'like-dislike',
}